//@flow
import React, {useCallback, useEffect, useMemo} from 'react';
import {getLangValue, LangLink, useMsgs} from "../lib/Language";
import {Breadcrumb, Card} from "react-bootstrap";
import {BreadcrumbItem, PageHeader} from "../lib/Components";
import DesktopScreen from "./DesktopScreen";
import {useRpcQuery} from "../lib/QueryUtils";
import type {ECReportInfo} from "../api";
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";
import {ReportParams} from "../lib/ReportParams";
import {store} from "../application";
import {getDownloadLink} from "../lib/Upload";

export const VindicationsReportsScreen = () => {
    const msgs=useMsgs();
    const query=useRpcQuery('/user', 'getVindicationReports');
    const history=useHistory();
    useEffect(() => {
        if(query.isSuccess && (!query.data || query.data.length===0)) {
            history.push(DesktopScreen.url);
        }
    }, [ query ]);

    return <>
        <Breadcrumb>
            <BreadcrumbItem to={DesktopScreen.url}>{msgs.gui.titleSummary}</BreadcrumbItem>
            <BreadcrumbItem active>{msgs.gui.menuVindicationReports}</BreadcrumbItem>
        </Breadcrumb>
        <PageHeader title={msgs.gui.menuVindicationReports}/>
        <Card className="shadow">
            <Card.Body>
                {query.isSuccess?<ul>
                    {query.data.map((r: ECReportInfo) => <li key={r.name}>
                        <LangLink to={VindicationReportScreen.link(r.name)}>{getLangValue(r.label)}</LangLink>
                    </li>)}
                </ul>:null}
            </Card.Body>
        </Card>
    </>
}

VindicationsReportsScreen.url="/debtcollection_reports";

export const VindicationReportScreen = ({}) => {
    const msgs=useMsgs();
    const query=useRpcQuery('/user', 'getVindicationReports');
    const { id } = useParams();
    const history=useHistory();

    const report:null|ECReportInfo=useMemo(() => {
        if(!query.data) return null;
        return query.data.find(r => r.name===id);
    }, [ query ]);

    useEffect(() => {
        if(query.isSuccess && !report) {
            history.push(VindicationsReportsScreen.url);
        }

    }, [ query, report ]);
    const title=report?getLangValue(report.label):id;
    const handleSubmit=useCallback(async (params) => {
        console.log("Params: ", params);
        const file=await store.userApi.getVindicationReportData(id, params);
        if (file) {
            window.location.href = getDownloadLink(file.safeId, file.name);
        }
    }, [ id ]);

    return <>
        <Breadcrumb>
            <BreadcrumbItem to={DesktopScreen.url}>{msgs.gui.titleSummary}</BreadcrumbItem>
            <BreadcrumbItem to={VindicationsReportsScreen.url}>{msgs.gui.menuVindicationReports}</BreadcrumbItem>
            <BreadcrumbItem active>{title}</BreadcrumbItem>
        </Breadcrumb>
        <PageHeader title={title}/>
        <Card className="shadow">
            <Card.Body>
                {report?<>
                    <ReportParams fields={report.parameters} onSubmit={handleSubmit}/>
                </>:null}
            </Card.Body>
        </Card>
    </>
}
VindicationReportScreen.url="/debtcollection_reports/:id";
VindicationReportScreen.link=(id: string) => `/debtcollection_reports/${encodeURIComponent(id)}`;


